import { stumble } from '@ipfabric/frontend-shared-assets/utils/stumble/stumble';
import type { ApiTableDataPatch } from 'components/ApiTable/model/ApiTableModel';
import { useLocale } from 'containers/App/LocaleContext';
import { useNotifications } from 'utils/hooks/useNotifications';
import { useSnapshotId } from 'utils/hooks/useSnapshotId';
import { useApi } from 'utils/request/useApi';

export type SeparateSitesHook = (
  newSiteNames: ApiTableDataPatch<{ newSiteName: string }>,
  global: boolean,
) => Promise<void>;

export const useSeparateSites = (): SeparateSitesHook => {
  const api = useApi();
  const manualSeparationMsg = useLocale().manualSeparation;
  const snapshotId = useSnapshotId();
  const { showNotification } = useNotifications();

  return async (newSiteNames, global) => {
    if (snapshotId === null) {
      stumble('No active snapshot, cannot perform site separation');
      return;
    }

    const attributes = Object.entries(newSiteNames).map(
      ([sn, { newSiteName }]) => ({
        name: 'siteName',
        sn,
        value: newSiteName,
      }),
    );

    await Promise.all([
      api.request({
        url: '/attributes/local',
        method: 'PUT',
        data: {
          attributes,
          snapshot: snapshotId,
        },
      }),
      global
        ? api.request({
            url: '/attributes/global',
            method: 'PUT',
            data: {
              attributes,
            },
          })
        : null,
    ]);
    showNotification({
      type: 'success',
      message: manualSeparationMsg.request.settingsApplied,
    });
  };
};
